export class CustomError extends Error {
    constructor(errorObj, errorMessage) {
        if (errorObj) {
            let message = errorObj.message
            if (errorMessage) {
                if (message) {
                    message = `${message} - ${errorMessage}`
                }
                else {
                    message = `${errorMessage}`
                }
            }
            super(message)
            this.stack = errorObj.stack
            this.name = errorObj.name
        }
        else {
            let message = "Error Object mising"
            if (errorMessage) {
                message = `${message} - ${errorMessage}`
            }
            super(message)
        }
    }
}